import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { INote, INoteModalParams } from "../../app/models/note";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Form as FinalForm, Field } from "react-final-form";
import { Alert, Button, Form, FormGroup } from "reactstrap";
import TextAreaInput from "../common/TextAreaInput";
import { FORM_ERROR } from "final-form";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

interface IParams {
  params: INoteModalParams;
}

const NoteForm: React.FC<IParams> = ({ params }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { resetNoteModalParams } = rootStore.playerStore;
  const { loadNote, submitNote, deleteNote } = rootStore.noteStore;
  const [note, setNote] = useState<INote | null>(null);
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleNoteSubmit = async (note: INote) => {
    if (note.text) await submitNote(params, note);
    else await deleteNote(params);
  };

  useEffect(() => {
    loadNote(params).then((n) => setNote(n));

    return () => {
      resetNoteModalParams();
    };
  }, [loadNote, params, resetNoteModalParams]);

  return (
    <>
      <FinalForm
        initialValues={note}
        onSubmit={(values: INote) =>
          handleNoteSubmit(values).catch((error) => ({
            [FORM_ERROR]: error,
          }))
        }
        render={({
          handleSubmit,
          submitting,
          submitError,
          invalid,
          pristine,
          dirtySinceLastSubmit,
          touched,
        }) => (
          <Form onSubmit={handleSubmit} role="form">
            <div>
              <FormGroup>
                <Field
                  id="text"
                  name="text"
                  component={TextAreaInput}
                  rows={6}
                  type="text"
                  className="form-control-alternative w-100"
                  readOnly={!note}
                />
              </FormGroup>
              {submitError && !dirtySinceLastSubmit && (
                <Alert color="danger">{t("toolbar_notes_form_error")}</Alert>
              )}
              <Button
                disabled={
                  (invalid && !dirtySinceLastSubmit) || pristine || !note
                }
                className={classNames(
                  "genericButton",
                  `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                    theme!.buttonTextColor
                  }`
                )}
                type="submit"
              >
                {t("toolbar_notes_form_save")}
              </Button>
            </div>
          </Form>
        )}
      />
    </>
  );
};

export default observer(NoteForm);
